/**
 * Prevents cover section resize on mobile devices when you scroll down
 */

import { TweenMax } from 'gsap';
import createEvent from '@/scripts/utils/create-event';

let timeout;

window.addEventListener('resize', () => {
  if (timeout) {
    clearTimeout(timeout);
  }
  setTimeout(() => {
    window.dispatchEvent(createEvent('resizeEnd'));
  }, 150);
});

let oldWidth;
let elements;

function resizeElements() {
  oldWidth = window.innerWidth;
  TweenMax.to(elements, 0.7, {
    height: Math.max(window.innerHeight, 550),
  });
}

document.addEventListener('DOMContentLoaded', () => {
  elements = $('.cover_full');
  resizeElements();
  window.addEventListener('resizeEnd', () => {
    if (oldWidth !== window.innerWidth) {
      resizeElements();
    }
  });
});



// WEBPACK FOOTER //
// ./scripts/elements/cover.js